var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ph-card",class:{grand: this.grandFinal, big_final: this.getGrandFinalClass}},[_c('div',{staticClass:"s1"},[_vm._v(_vm._s(_vm.getRound))]),_c('div',{staticClass:"s2"})])}
var staticRenderFns = []

export { render, staticRenderFns }